// Client API de l'Assistant ZOS.
import { translate } from '../i18n';

const BASE_URL = import.meta.env.VITE_WATTELZCE_API_URL || '';

export interface AssistantMessage {
  role: 'user' | 'assistant';
  content: string;
}

/** Série de valeurs jointe à une réponse (ex. consommation par jour), tracée en mini-histogramme. */
export interface AssistantAttachment {
  type: 'series';
  title: string;
  unit: string;
  points: Array<{ label: string; value: number }>;
}

export interface AssistantReply {
  reply: string;
  attachments: AssistantAttachment[];
  toolsUsed: string[];
}

export async function askAssistant(messages: AssistantMessage[], signal?: AbortSignal): Promise<AssistantReply> {
  const token = localStorage.getItem('dashboard_zce_token');
  const controller = new AbortController();
  const timer = setTimeout(() => controller.abort(), 90_000);
  const onAbort = () => controller.abort();
  signal?.addEventListener('abort', onAbort);
  try {
    const res = await fetch(`${BASE_URL}/api/assistant/chat`, {
      method: 'POST',
      signal: controller.signal,
      headers: {
        'Content-Type': 'application/json',
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
      body: JSON.stringify({ messages }),
    });
    const body = await res.json().catch(() => ({}));
    // seuls les messages métier (chaîne) sont affichés ; une erreur serveur retombe sur le message générique
    const errMsg = typeof body.error === 'string' ? body.error : undefined;
    if (!res.ok) throw new Error(errMsg || translate('adm_err_status', { status: res.status }));
    return { reply: body.reply ?? '', attachments: body.attachments ?? [], toolsUsed: body.toolsUsed ?? [] };
  } finally {
    clearTimeout(timer);
    signal?.removeEventListener('abort', onAbort);
  }
}
